import { Button, Col, DatePicker, Empty, Form, Row, Select, Space, Upload } from 'antd'
import { CounterpartyFormProps } from '../counterparty/CounterpartyForm'
import useFetchData from '../../../../hooks/useFetchData'
import { AgreementTypeDtoResponse } from '../../../../interfaces/AgreementTypeDtoResponse'
import { CounterpartyService } from '../../../../services/CounterpartyService'
import useCounterparty from '../counterparty/useCounterparty'
import moment from 'moment'
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import useCounterpartyAgreement from './useCounterpartyAgreement'

const CounterpartyAgreementForm = ({ form, onFinish }: CounterpartyFormProps) => {
    const { data: agreementTypes } = useFetchData<AgreementTypeDtoResponse[]>(CounterpartyService.getCounterpartyAgreementTypes, true);
    const { counterparties, debouncedFetchCounterparties } = useCounterparty();
    const { handleDownload } = useCounterpartyAgreement();

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            form={form}
        >
            <Form.Item
                name="counterpartyId"
                label="БИН"
                rules={[
                    { required: true, message: 'БИН не должен быть пустым!' },
                ]}
            >
                <Select
                    showSearch
                    placeholder="Введите БИН"
                    onSearch={debouncedFetchCounterparties}
                    filterOption={false}
                    notFoundContent={<Empty />}
                >
                    {counterparties?.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                            {`${item.nameEn} / ${item.nameRu} / ${item.nameKz} — (${item.bin})`}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item
                name="agreementTypeId"
                label="Тип"
                rules={[{ required: true, message: 'Пожалуйста, выберите тип!' }]}
            >
                <Select>
                    {agreementTypes?.map((type) => (
                        <Select.Option key={type.id} value={type.id}>
                            {type.nameRu + " / " + type.nameEn + " / " + type.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Row gutter={[12, 12]}>
                <Col span={12}>
                    <Form.Item
                        name="startDate"
                        label="Дата начала"
                        getValueProps={(i) => i ? { value: moment(i) } : { value: '' }}
                        getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}
                        rules={[{ required: true, message: 'Пожалуйста, введите дату начала!' }]}
                    >
                        <DatePicker />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name="endDate"
                        label="Дата окончания"
                        getValueProps={(i) => i ? { value: moment(i) } : { value: '' }}
                        getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}
                    >
                        <DatePicker />
                    </Form.Item>
                </Col>
            </Row>
            {form.getFieldValue('fileId') ? (
                <Space>
                    <Form.Item
                        name="file"
                        label="Файл"
                        getValueFromEvent={(e: any) => {
                            if (Array.isArray(e)) {
                                return e;
                            }
                            console.log(e);
                            return e && e.fileList[0].originFileObj;
                        }}
                    >
                        <Upload maxCount={1} beforeUpload={() => false}>
                            <Button icon={<UploadOutlined />}>Загрузите файл</Button>
                        </Upload>
                    </Form.Item>
                    <Button icon={<DownloadOutlined />} type='link' onClick={() => handleDownload(form.getFieldValue('fileId'))}>Скачать файл</Button>
                </Space>
            ) : (
                <Form.Item
                    name="file"
                    label="Файл"
                    getValueFromEvent={(e: any) => {
                        if (Array.isArray(e)) {
                            return e;
                        }
                        return e && e.fileList[0].originFileObj;
                    }}
                    rules={[{ required: true, message: 'Пожалуйста, загрузите файл!' }]}
                >
                    <Upload maxCount={1} beforeUpload={() => false}>
                        <Button icon={<UploadOutlined />}>Загрузите файл</Button>
                    </Upload>
                </Form.Item>
            )}
        </Form>
    )
}

export default CounterpartyAgreementForm